import { Box, ColorOptions, ModBox, RadioButton, TextNew } from '@jfs/ui-new'
import { TextInputNew } from '../../../../../components/AdminInputs'
import { useState } from 'react'
import { EmType } from '../../..'
import { ExpandableTextView } from '../../../../../components/ExpandableTextView'
import { TerminalListItem } from '../../../../../components/TerminalListItem'
import { camelCaseToTitleCase } from '../../../../../utils'
import { CompoundCheckbox } from '../../../../SelectYourEmi/CompoundCheckbox'
import { DownloadFileComp } from '../../../CreateBulkEntities/UploadedFileDetails/DownloadFileComp'
import { StatusBox } from '../../../CreateBulkEntities/UploadedFileDetails/StatusBox'
import { DownloadViewComp } from '../../../CreateBulkEntities/UploadedFileHistory/DownloadViewComp'
import { DefaultCheckNDelete } from './DefaultCheckNDelete'
import { Delete } from './Delete'
import { EditDelete } from './EditDelete'
import { Undo } from './Undo'
import { styles } from './styles'

interface FlatListInterface {
  item: any
  index: number
  onRowPress: (item: any) => void
  selectedParentData: number | string | null
  columnFlexMapper: any[]
  dataLength: number
  showBorder?: boolean
  type?: string
  childTextAlignment?: 'left' | 'center' | 'right'
  onTextInputChange?: (id: string, gstNumber: string) => void
  onDelete?: (item: any) => void
  updateDefaultSelection?: (id: string, isChecked: string) => void
  onCheckboxPress?: (id: string, isChecked: boolean) => void
  onViewPress?: (data: any) => void
  onDownloadPress?: (data: any) => void
  isEditMode?: boolean
  onEditPress?: (item: any) => void
  onUndoPress?: (item: any) => void
  onReplace?: (item: any) => void
  hideColumnNames?: string[]
}

const RenderIndividualRowData = ({
  title,
  item,
  itemKey,
  flex,
  getChecked,
  isSelected,
  type,
  childTextAlignment,
  onTextInputChange,
  onDelete,
  updateDefaultSelection,
  onCheckboxPress,
  onViewPress,
  onDownloadPress,
  isEditMode,
  onEditPress,
  onUndoPress,
  onReplace,
  hideColumnNames = [],
}: {
  title: string | any
  item: any
  itemKey: string
  flex: number
  getChecked: any
  isSelected: boolean
  type?: string
  childTextAlignment?: 'left' | 'center' | 'right'
  onTextInputChange: any
  onDelete: any
  updateDefaultSelection: any
  onCheckboxPress: any
  onViewPress: any
  onDownloadPress: any
  isEditMode?: boolean
  onEditPress?: (item: any) => void
  onUndoPress?: (item: any) => void
  onReplace?: (item: any) => void
  hideColumnNames?: string[]
}) => {
  const [textInputValue, setTextInputValue] = useState('')
  const isStatusComp =
    (typeof title === 'string' && title?.toString()?.toLowerCase() === 'active') ||
    title?.toString()?.toLowerCase() === 'terminated' ||
    title?.toString()?.toLowerCase() === 'processed' ||
    title?.toString()?.toLowerCase() === 'failed' ||
    title?.toString()?.toLowerCase() === 'approved' ||
    title?.toString()?.toLowerCase() === 'rejected' ||
    title?.toString()?.toLowerCase() === 'expired' ||
    title?.toString()?.toLowerCase() === 'synced with mas' ||
    title?.toString()?.toLowerCase() === 'available' ||
    itemKey === 'deviceStatus' ||
    itemKey === 'status' ||
    title?.toString()?.toLowerCase() === 'completed' ||
    title?.toString()?.toLowerCase() === 'in_progress' ||
    title?.toString()?.toLowerCase() === 'blocked' ||
    title?.toString()?.toLowerCase() === 'confirmed' ||
    title?.toString()?.toLowerCase() === 'replaced'

  const isViewEditDownldDeleteComp =
    typeof title === 'string' &&
    (title?.toString()?.toLowerCase().startsWith('view_') ||
      title?.toString()?.toLowerCase().startsWith('edit_') ||
      title?.toString()?.toLowerCase().startsWith('delete_') ||
      title?.toString()?.toLowerCase().startsWith('download_'))

  const deleteOnly = itemKey === 'deleteOnly' || title === 'deleteOnly'
  const isDownloadViewComp = typeof title === 'string' && title?.toString()?.toLowerCase() === 'download_view'
  const isCustomElement = typeof title === 'object'
  const isTextLink =
    itemKey === 'tid' ||
    itemKey === 'unlink' ||
    itemKey === 'parentId' ||
    itemKey === 'viewDetails' ||
    itemKey === 'id' ||
    itemKey === 'NAME'
  const CustomComp = title
  const textInput = itemKey === 'gstNumber'
  const checkBoxNDelete = itemKey === 'isDefault'
  const isCheckBox = itemKey === 'checkBox'
  const isTidQrItem = itemKey === 'vpaQrUrl'
  const isEditDelete = item?.status?.toLowerCase() !== 'terminated' && itemKey === '_editDelete'
  const isUndo = itemKey === '_undo'
  const isReplace = itemKey === '_replace'

  const onDeleteRow = () => {
    onDelete && onDelete(item)
  }

  const onViewCellPressed = (item: any) => {
    console.log('onViewCellPressed')
    onViewPress && onViewPress(item)
  }

  const onDownloadCellPress = (item: any) => {
    console.log('onDownloadCellPress')
    onDownloadPress && onDownloadPress(item)
  }

  const onCheckedChange = (isChekd: string) => {
    updateDefaultSelection && updateDefaultSelection(item, isChekd)
  }

  const onChangeText = (gstNum: string) => {
    setTextInputValue(gstNum)
    onTextInputChange && onTextInputChange(item?.id, gstNum)
  }

  const onCheckboxChange = (isChecked: boolean) => {
    onCheckboxPress && onCheckboxPress(item, isChecked)
  }
  return (
    <ModBox
      flex={flex}
      height={'100%'}
      ph={4}
      show={!(hideColumnNames && hideColumnNames?.length > 0 && hideColumnNames?.includes(itemKey))}>
      <ModBox
        show={
          itemKey !== 'select' &&
          !isTextLink &&
          !isCustomElement &&
          !isStatusComp &&
          !isViewEditDownldDeleteComp &&
          !textInput &&
          !isCheckBox &&
          type !== EmType.createSingleEntity &&
          !isTidQrItem &&
          !deleteOnly &&
          !isEditDelete &&
          !isUndo &&
          itemKey !== 'directorReferenceId' &&
          itemKey !== 'authorisedSignatoryReferenceId' &&
          itemKey !== 'beneficialOwnerReferenceId' &&
          !isReplace
        }>
        <ExpandableTextView
          // eslint-disable-next-line react-native/no-inline-styles
          textStyle={{
            numberOfLines: 1,
            ...styles.valueText,
            textAlign: childTextAlignment,
          }}
          text={title}
          rowData={{ [itemKey]: title }}
          commentsData={[{ key: itemKey, heading: camelCaseToTitleCase(itemKey) }]}
          modelTitle={itemKey}
        />
      </ModBox>
      <ModBox show={isCustomElement}>{CustomComp}</ModBox>
      <ModBox show={isStatusComp && title}>
        <StatusBox status={title} alignment={'flex-start'} />
      </ModBox>
      <ModBox show={isViewEditDownldDeleteComp && !isDownloadViewComp}>
        <DownloadFileComp
          type={title?.toString()?.split('_')?.[0]}
          title={title?.toString()?.split('_')?.[1]}
          onButtonPress={onDownloadCellPress}
          data={item}
        />
      </ModBox>
      <ModBox show={isDownloadViewComp}>
        <DownloadViewComp onDownloadPress={onDownloadCellPress} onViewPress={onViewCellPressed} data={item} />
      </ModBox>
      <ModBox show={itemKey === 'select'}>
        <RenderRadioButton flex={flex} item={item} getChecked={getChecked} isSelected={isSelected} />
      </ModBox>
      <ModBox
        show={type !== undefined && itemKey === 'current' && type === EmType.createSingleEntity}
        h={21}
        justify={'center'}>
        <TextInputNew numberOfLines={1} value={title} {...styles.textinputStyle(true)} />
      </ModBox>
      <ModBox show={isTextLink && !isCustomElement}>
        <TextNew numberOfLines={1} {...styles.linkText} title={title} />
      </ModBox>
      <ModBox show={textInput && !isCustomElement} alignItems={'center'} justify={'center'}>
        <ModBox show={isEditMode}>
          <TextInputNew
            padding={8}
            numberOfLines={1}
            borderColor={'GRAY_BORDER'}
            value={textInputValue}
            maxLength={15}
            borderRadius={4}
            onChangeText={onChangeText}
            {...styles.textinputStyle(isEditMode)}
          />
        </ModBox>
        <ModBox show={!isEditMode}>
          <TextNew numberOfLines={1} {...styles.valueText} textAlign={childTextAlignment} title={title} />
        </ModBox>
      </ModBox>
      <ModBox show={checkBoxNDelete && !isCustomElement}>
        <DefaultCheckNDelete
          onCheckedChange={onCheckedChange}
          isChecked={item?.isDefault}
          isEdit={false}
          onDelete={onDeleteRow}
        />
      </ModBox>
      <ModBox show={isCheckBox && !isCustomElement}>
        <CompoundCheckbox isChecked={item?.checkBox} onCheckboxPress={onCheckboxChange} isEdit={isEditMode} />
      </ModBox>
      {/* <ModBox
        show={isCustomElement && !isStatusComp}
        alignItems={'center'}
        justify={'center'}
        borderWidth={1}
        borderColor={'RED'}>
        <CompoundCheckbox isChecked={item?.checkBox} onCheckboxPress={onCheckboxChange} />
      </ModBox> */}
      <ModBox show={isTidQrItem}>
        <TerminalListItem item={item} />
      </ModBox>
      <ModBox show={deleteOnly}>
        <Delete onDelete={onDeleteRow} isEditMode={isEditMode} />
      </ModBox>
      <ModBox show={isEditDelete}>
        <EditDelete onDelete={onDeleteRow} onEdit={onEditPress} item={item} />
      </ModBox>
      <ModBox show={isUndo}>
        <Undo onPress={onUndoPress} item={item} />
      </ModBox>
      <ModBox show={isReplace && !isCustomElement && !isTextLink}>
        <ModBox direction="row">
          <TextNew numberOfLines={1} {...styles.linkText} title={title} />
          <StatusBox status={'Replaced'} alignment={'center'} />
        </ModBox>
      </ModBox>
    </ModBox>
  )
}

const RenderRadioButton = ({ flex, item, getChecked, isSelected }: any) => {
  const onCheckChange = (isChkd: string) => {
    console.log('RenderRadioButton', isChkd)
    getChecked(item)
  }
  return (
    <Box f={flex} {...styles.radioButton}>
      <RadioButton
        onChange={onCheckChange}
        size={14}
        minItemHeight={10}
        color={isSelected ? 'BLUE_SHADE_PRIMARY' : ('#C4C4C4' as ColorOptions)}
        padding={0}
        disabled
        checked={isSelected}
      />
    </Box>
  )
}

export const RenderFlatListData = ({
  item,
  index,
  onRowPress,
  selectedParentData,
  columnFlexMapper,
  dataLength,
  showBorder = true,
  type,
  childTextAlignment,
  onTextInputChange,
  onDelete,
  updateDefaultSelection,
  onCheckboxPress,
  onViewPress,
  onDownloadPress,
  isEditMode,
  onEditPress,
  onUndoPress,
  onReplace,
  hideColumnNames,
  rowDataMapperKeys,
}: FlatListInterface) => {
  const isLastItem = showBorder ? index + 1 === dataLength : false
  const isSelected = item?.groupId === selectedParentData || item?.isSelected === true
  const getChecked = (checkedData: any) => {}
  const keysList = (
    rowDataMapperKeys?.length > 0 ? rowDataMapperKeys.map((item) => item.title) : Object.keys(item)
  ).filter((item) => !hideColumnNames?.includes(item))
  console.log('htag  item=', keysList)

  return (
    <Box
      {...styles.renderItemBox(isLastItem, showBorder)}
      onPress={() => onRowPress(item)}
      underlayColor={'LIGHTEST_GREY'}>
      {keysList.map((key, index) => (
        <RenderIndividualRowData
          title={item[key]}
          item={item}
          itemKey={key}
          flex={columnFlexMapper[index] ?? 1}
          getChecked={getChecked}
          isSelected={isSelected}
          type={type}
          childTextAlignment={childTextAlignment}
          onTextInputChange={onTextInputChange}
          onDelete={onDelete}
          updateDefaultSelection={updateDefaultSelection}
          onCheckboxPress={onCheckboxPress}
          onViewPress={onViewPress}
          onDownloadPress={onDownloadPress}
          isEditMode={isEditMode}
          key={key}
          onEditPress={onEditPress}
          onUndoPress={onUndoPress}
          onReplace={onReplace}
          hideColumnNames={hideColumnNames}
        />
      ))}
    </Box>
  )
}
